function WhiteYoutube() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7713 2.84184C18.6683 2.47455 18.4677 2.14202 18.1909 1.8796C17.9062 1.60911 17.5573 1.41563 17.1771 1.3174C15.7542 0.942356 10.0535 0.942356 10.0535 0.942356C7.67689 0.915316 5.3009 1.03424 2.93891 1.29846C2.5587 1.40394 2.21045 1.60175 1.92514 1.8743C1.6448 2.14403 1.44174 2.47665 1.33567 2.84109C1.08086 4.2138 0.957051 5.60762 0.965922 7.00375C0.95683 8.39863 1.08033 9.79199 1.33567 11.1664C1.43947 11.5293 1.64177 11.8604 1.92286 12.1279C2.20396 12.3954 2.55401 12.5886 2.93891 12.6909C4.38076 13.0651 10.0535 13.0651 10.0535 13.0651C12.4331 13.0922 14.8121 12.9733 17.1771 12.709C17.5573 12.6108 17.9062 12.4173 18.1909 12.1468C18.4676 11.8845 18.668 11.5519 18.7705 11.1846C19.032 9.81241 19.1591 8.41802 19.1501 7.02118C19.1698 5.61842 19.0428 4.21745 18.7713 2.84109V2.84184ZM8.24111 9.59803V4.41023L12.9841 7.00451L8.24111 9.59803Z"
        className="fill-white hover:fill-grey-7"
      />
    </svg>
  );
}

export default WhiteYoutube;
